export default __webpack_public_path__ + "static/media/create.909f537c.svg";